import { AfterViewInit, Component, OnInit } from '@angular/core'

import { MENU_ITEMS, MenuProfileData } from './pages-menu'
import { ConfigService } from '../@core/services/config.service'
import { UserService } from '../@core/services/user.service'
import { SharedService } from '../@core/services/shared.service'
import { LocalStorageService } from '../@core/utils'
import { NbAuthOAuth2JWTToken, NbAuthService } from '@nebular/auth'
import { PvsResponse } from '../@core/services/pvs-request.service'

@Component({
    selector: 'app-pages',
    styleUrls: ['pages.component.scss'],
    template: `
        <app-one-column-layout>
            <nb-menu [items]="menu"></nb-menu>
            <router-outlet></router-outlet>
        </app-one-column-layout>
    `,
})
export class PagesComponent implements OnInit, AfterViewInit {
    menu = MENU_ITEMS
    constructor(
        private authService: NbAuthService,
        private configService: ConfigService,
        private localStorageService: LocalStorageService,
        private userService: UserService,
        public sharedService: SharedService
    ) {}

    ngOnInit(): void {
        this.authService.onTokenChange().subscribe((jwtToken: NbAuthOAuth2JWTToken) => {
            if (jwtToken.isValid) {
                const parsed = JSON.parse(JSON.stringify(jwtToken))
                if (parsed.token?.origin) {
                    // only update when data changed <= important
                    if (
                        !this.sharedService.currentUser?.id ||
                        this.sharedService.currentUser.id !== parsed.token.origin.user.id
                    ) {
                        this.sharedService.currentUser = parsed.token.origin.user
                    }

                    // only update when data changed <= important
                    if (
                        !this.sharedService.localStorageService.refreshToken ||
                        this.sharedService.localStorageService.refreshToken !== parsed.token.origin['refresh_token']
                    ) {
                        this.sharedService.localStorageService.accessToken = parsed.token.origin['access_token']
                        this.sharedService.localStorageService.refreshToken = parsed.token.origin['refresh_token']
                    }
                }
            } else {
                this.sharedService.currentUser = null
                this.sharedService.localStorageService.clearAll()
            }
        })
    }

    ngAfterViewInit(): void {
        this.getProfile()
    }

    getProfile(): void {
        const request = this.userService.getProfile()
        request.usingLoadingBar = false
        request.subscribe(
            (response: PvsResponse) => {
                // update current user information ↓
                const user = this.sharedService.currentUser
                Object.keys(user).forEach((key) => {
                    if (typeof response?.data[key] !== 'undefined') {
                        user[key] = response.data[key]
                    }
                })
                this.sharedService.currentUser = user
                // update current user information ↑
                this.sharedService.salons = response?.data?.salons || []
                let currentSalon = this.sharedService.currentSalon
                if (currentSalon) {
                    // check saved salon in storage is valid or not
                    currentSalon = this.sharedService.salons.find((s) => s.id === currentSalon.id)
                }
                if (!currentSalon) {
                    // set default salon
                    if (this.sharedService.salons.length) {
                        currentSalon = this.sharedService.salons[0]
                    }
                    // currentSalon = this.sharedService.salons.find((s) => s?.me?.isDefault === true)
                }
                this.sharedService.currentSalon = currentSalon
                //
                this.menu = this.menu.map((e) => {
                    e.hidden = !(e.displayWhenInit ?? true) // false if not be defined
                    if (typeof e.hiddenCondition === 'function') {
                        e.hidden = e.hiddenCondition({
                            profile: response.data,
                            currentSalon: this.sharedService.currentSalon,
                        })
                    }
                    return e
                })
            },
            () => {
                // don't show the error message
                console.error('Get profile failed.')
            }
        )
    }
}
